import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "./NewHire.css";
import { useDispatch, useSelector } from "react-redux";
import { UseGeneratePDF } from "../Employee/UseGeneratePDF";
import { EMP_USER_DETAILS } from "../../Redux/NewHire/ActionType";
import { FaList } from "react-icons/fa";
import { HiUserRemove } from "react-icons/hi";
import Select from 'react-select';
import { IoArrowRedoSharp } from "react-icons/io5";


import {
  createUser,
  getDesignation,
  getEducationDetails,
  getExperienceDetails,
  getFamilyDetails,
  getPersonalDetails,
  getRoleList,
  getUserByLoginId,
  getUserDocumentDetails,
  getUserList,
  markEmployeeExit,
  validateUser,
  instantOnboarding,
} from "../../Redux/NewHire/Action";
import Swal from "sweetalert2";
import { FaEdit, FaUserPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "jspdf-autotable";
import { NEWHIRE_USER_DETAILS } from "../../Redux/NewHire/ActionType";
import { fetchClientDetails } from "../../Redux/Config/Action";
import NewDataTable from "../DataTable/NewDataTable";
import * as XLSX from "xlsx";
import { autoFitColumns, prepareExcelData } from "../utility/excelUtils";
import { FaFileExcel } from "react-icons/fa6";


const NewHire = () => {
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    desiglist,
    userlist,
    rolelists,
    validationStatus,
    statusDesc,
    field,
    newHireUserDetails,
    personalDetails,
    familyListDetails,
    educationListDetails,
    experienceListDetails,
    userdocslist,
    empUserDetails,
  } = useSelector((store) => store.newHireData);
  const [show, setShow] = useState(false);
  const [emailValidationMessage, setEmailValidationMessage] = useState("");
  const [panValidationMessage, setPanValidationMessage] = useState("");
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [generatePdfFlag, setGeneratePdfFlag] = useState(false);
  const { clientDetails } = useSelector((store) => store.config);
  const { generatePDF } = UseGeneratePDF();
  const [userdesignation, setUserdesignation] = useState("");
  const [exitModal, setExitModal] = useState(false);
  const [showInstantOnboardingModal, setShowInstantOnboardingModal] = useState(false);


  useEffect(() => {
    dispatch(getDesignation(token));
    dispatch(getRoleList(token));
    dispatch(getUserList(token));
  }, [dispatch, token]);

  const [formData, setFormData] = useState({
    userId: "",
    firstName: "",
    lastName: "",
    personalEmail: "",
    dateOfBirth: "",
    pan: "",
    role: "",
    designation: "",
    actionType: "INSERT",
  });

  const handleClose = () => {
    clearUserInputFields();
    setShow(false);
  };
  const handleShow = () => {
    setFormData({
      userId: "",
      firstName: "",
      lastName: "",
      personalEmail: "",
      dateOfBirth: "",
      pan: "",
      role: "",
      designation: "",
      actionType: "INSERT",
    });
    setShow(true);
  };

  useEffect(() => {
    if (newHireUserDetails) {
      const matchedRole = rolelists.find(
        (role) => role.roleName === newHireUserDetails.role
      );
      setFormData({
        userId: newHireUserDetails.loginId || "",
        firstName: newHireUserDetails.firstName || "",
        lastName: newHireUserDetails.lastName || "",
        personalEmail: newHireUserDetails.personalEmail || "",
        dateOfBirth: newHireUserDetails.dob || "",
        pan: newHireUserDetails.pan || "",
        role: matchedRole ? matchedRole.roleId : "",
        designation: newHireUserDetails.designationId
          ? newHireUserDetails.designationId
          : "",
        actionType: "UPDATE",
      });
    }
  }, [newHireUserDetails, rolelists]);

  useEffect(() => {
    if (formData.actionType === "UPDATE") {
      setSubmitEnabled(true);
    }

    if (field === "personalEmail") {
      if (validationStatus === "99") {
        setEmailValidationMessage(statusDesc);
        setSubmitEnabled(false);
      } else if (validationStatus === "00") {
        setEmailValidationMessage("");
        setSubmitEnabled(true);
      }
    }

    if (field === "pan") {
      if (validationStatus === "99") {
        setPanValidationMessage(statusDesc);
        setSubmitEnabled(false);
      } else if (validationStatus === "00") {
        setPanValidationMessage("");
        setSubmitEnabled(true);
      }
    }
  }, [validationStatus, statusDesc, field, formData.actionType]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    if (
      (name === "firstName" || name === "lastName") &&
      /[^a-zA-Z\s]/.test(value)
    ) {
      e.preventDefault();
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "pan" ? value.toUpperCase() : value,
    }));

    if (name === "personalEmail" || name === "pan") {
      dispatch(validateUser({ ...formData, [name]: value }, name, token));
    }
  };

  const handleDateChange = (date, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: date ? format(date, "yyyy-MM-dd") : "",
    }));
  };

  const handleOnboardDateChange = (date, name) => {
    setInstantOnboardData((prevData) => ({
      ...prevData,
      [name]: date ? format(date, "yyyy-MM-dd") : "",
    }));
  };

  const clearUserInputFields = () => {
    setFormData([
      {
        userId: "",
        firstName: "",
        lastName: "",
        personalEmail: "",
        dateOfBirth: "",
        pan: "",
        role: "",
        designation: "",
        actionType: "INSERT",
      },
    ]);
  };

  const [exitFormData, setExitFormData] = useState({
    userId: "",
    exitDate: "",
    firstName: "",
  })

  const [instantOnboardData, setInstantOnboardData] = useState({
    loginId: "",
    userId: "",
    joiningDate: "",
    role: "",
    empId: "",
    firstName: "",
  })

  const handleExitEmpclick = (row) => {
    setExitFormData({
      userId: row.loginId,
      firstName: row.firstName + " " + row.lastName,
    })
    setExitModal(true);
  }

  const handleExitEmpDateChange = (date, name) => {
    setExitFormData((prevData) => ({
      ...prevData,
      [name]: date ? format(date, "yyyy-MM-dd") : "",
    }));
  };


  const handleExitEmployeeSubmit = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(markEmployeeExit(exitFormData, token))
        .then((result) => {
          if (result.success) {
            dispatch(getUserList(token));
            setExitModal(false);
            Swal.fire({
              title: "Success!",
              text: "User marked as deactivated successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: result.error || "User marked as deactivated unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Swal.fire({
            title: "Error!",
            text: "There was an error submitting the user details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });

    }
  };
  const handleEditUser = (row) => {
    dispatch(getUserByLoginId(row.loginId, token, NEWHIRE_USER_DETAILS));
    setShow(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.role || !formData.designation) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please fill all the required fields.",
        timer: 2000,
      });
      return;
    }


    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(createUser(formData, token))
        .then(({ response }) => {
          if (response.statusMessage === "SUCCESS") {
            dispatch(getUserList(token));
            setShow(false);
            Swal.fire({
              title: "Success!",
              text: "User details submitted successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
            {
              formData.actionType === 'INSERT' &&
                navigate("/onboarding", { state: { rowData: response.user } });
            }
          } else {
            Swal.fire({
              title: "Error!",
              text: "User details submitted unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error submitting the user details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleInstantOnboardingSubmit = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(instantOnboarding(instantOnboardData, token))
        .then((response) => {
          if ("00" === response.statusCode) {
            dispatch(getUserList(token));
            setShowInstantOnboardingModal(false);
            Swal.fire({
              title: "Success!",
              text: "Instant onboarding completed successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.statusDesc || "Instant onboarding failed",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "Error!",
            text: error.message || "There was an error submitting the user details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  }

  const handleViewClick = async (row) => {

    const designation = desiglist.find(
      (desig) => desig.designationId === row.designationId
    );

    if (designation) setUserdesignation(designation.designationName);
    await Promise.all([
      dispatch(getUserByLoginId(row.loginId, token, EMP_USER_DETAILS)),
      dispatch(getPersonalDetails(row.loginId, token)),
      dispatch(getFamilyDetails(row.loginId, token)),
      dispatch(getEducationDetails(row.loginId, token)),
      dispatch(getExperienceDetails(row.loginId, token)),
      dispatch(getUserDocumentDetails(row.loginId, token)),
      dispatch(fetchClientDetails(token)),
    ]);
    setGeneratePdfFlag(true);
  };

  useEffect(() => {
    if (generatePdfFlag) {
      if (
        empUserDetails &&
        personalDetails &&
        familyListDetails &&
        educationListDetails &&
        experienceListDetails &&
        clientDetails
      ) {
        generatePDF(
          empUserDetails,
          personalDetails,
          familyListDetails,
          educationListDetails,
          experienceListDetails,
          clientDetails,
          userdesignation,
          userdocslist,
        );
        setGeneratePdfFlag(false);
      }
    }
  }, [
    empUserDetails,
    personalDetails,
    familyListDetails,
    educationListDetails,
    experienceListDetails,
    clientDetails,
    generatePdfFlag,
    generatePDF,
  ]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const hireDetails = (row) => {
    navigate("/newHireDetails", { state: { rowData: row } });
  };

  const handleOnboarding = (row) => {
    navigate("/onboarding", { state: { rowData: row } });
  };

  const handleInstantOnboarding = (row) => {
    setShowInstantOnboardingModal(true);
    setInstantOnboardData((prev) => ({
      ...prev,
      userId: row?.loginId,
      loginId: loginId,
      firstName: `${row?.firstName || ""} ${row?.lastName || ""}`.trim(),
    }))
  }

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const columns = [
    {
      name: "SN",
      cell: (_, index) => index + 1,
      sortable: false,
      width: "80px",
      align: "center",
    },
    {
      name: "Name",
      selector: (row) => `${row.firstName?.trim() || ""} ${row.lastName?.trim() || ""}`.trim() || "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Dob",
      selector: (row) => formatDate(row.dob),
      sortable: true,
      align: "center",
    },
    {
      name: "Mobile Number",
      selector: (row) => row?.mobileNumber || "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Personal Email",
      selector: (row) => row.personalEmail?.trim() || "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Designation",
      selector: (row) => {
        const designation = desiglist.find(
          (desig) => desig.designationId === row.designationId
        );
        return designation?.designationName || "Unknown";
      },
      sortable: true,
      align: "center",
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      width: "226px",
      align: "center",
      cell: (row) => (
        <div>
          {(row.status !== "I" && row.status !== "A") && (
            <Tooltip text="Edit">
              <button
                type="button"
                className="btn btn-warning btn-sm me-2"
                onClick={() => handleEditUser(row)}
              >
                <FaEdit />
              </button>
            </Tooltip>
          )}

          <Tooltip text="Onboarding">
            <button
              type="button"
              className="btn btn-success btn-sm me-2"
              onClick={() => handleOnboarding(row)}
            >
              <FaUserPlus />
            </button>
          </Tooltip>
          <Tooltip text="Personal Info">
            <button
              type="button"
              className="btn btn-sm me-2 cs-btn-personal"
              onClick={() => hireDetails(row)}
            >
              <FaList />
            </button>
          </Tooltip>
          <Tooltip text="Instant Onboarding">
            <button
              type="button"
              className="btn btn-info btn-sm me-2"
              onClick={() => handleInstantOnboarding(row)}
            >
              <IoArrowRedoSharp />
            </button>
          </Tooltip>
          <Tooltip text="Deactivate User">
            <button
              type="button"
              className="btn btn-danger btn-sm me-2"
              onClick={() => handleExitEmpclick(row)}
            >
              <HiUserRemove />
            </button>
          </Tooltip>

        </div>
      ),
    },
  ];


  const designationMap = React.useMemo(() => {
    const map = {};
    desiglist?.forEach(d => {
      map[d.designationId] = d.designationName;
    });
    return map;
  }, [desiglist]);


  const excelColumns = [
    { header: "S.No", key: "sn" },
    {
      header: "Name",
      value: (row) => [row.firstName, row.lastName].filter(Boolean).join(" ")
    },
    { header: "DOB", key: "dob", type: "date" },
    { header: "Mobile Number", key: "mobileNumber" },
    { header: "Personal Email", key: "personalEmail" },
    { header: "PAN", key: "pan" },
    {
      header: "Designation",
      value: row => designationMap[row.designationId] || ""
    }
  ];

  const downloadExcel = () => {

    if (userlist?.length > 0) {

      const excelData = prepareExcelData(userlist, excelColumns);

      const ws = XLSX.utils.json_to_sheet(excelData);
      autoFitColumns(ws);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "NewHires");

      XLSX.writeFile(wb, "New Hires.xlsx");
    }
  };

  const roleOptions = rolelists.filter(r => r.roleName === "ROLE_CANDIDATE").map(c => ({
    value: c.roleId,
    label: c.roleName,
  }));

  const desigOptions = desiglist.map(c => ({
    value: c.designationId,
    label: c.designationName,
  }));

  const roleOptionsForApproval = rolelists.filter((role) =>
    ["ROLE_EMP", "ROLE_CONTRACT", "ROLE_SUPPORT"].includes(role.roleName)
  ).map(c => ({
    value: c.roleName,
    label: c.roleName,
  }));





  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">
          <div className="row mb-3 justify-content-end align-items-center">
            <div className="col-auto d-flex align-items-center">
              {userlist && userlist.length > 0 &&
                <FaFileExcel
                  size={28}
                  color="green"
                  title="Download Excel"
                  style={{ cursor: "pointer" }}
                  onClick={downloadExcel}
                />
              }
              <button className="ms-4 btn btn-primary" onClick={handleShow}>
                CREATE USER
              </button>
            </div>
          </div>
          {userlist && userlist.length > 0 ? (
            <div>
              <div>
                <NewDataTable
                  columns={columns}
                  data={userlist || []}
                  tableName="NEW HIRES"
                  totalRecord={userlist?.length}
                />
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <p>No data available.</p>
            </div>
          )}

          {show && (
            <>
              <div className="modal-backdrop fade show"></div>
              <div
                className="modal fade newhire-modal show"
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
              >
                <div
                  className="modal-dialog modal-lg modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {formData.actionType === "INSERT"
                          ? "Create User"
                          : "Edit User"}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleClose}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>First Name</b>
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                required
                                maxLength="100"
                                name="firstName"
                                value={formData.firstName || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>Last Name</b>
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                required
                                maxLength="100"
                                name="lastName"
                                value={formData.lastName || ""}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>Email Id</b>
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                required
                                maxLength="100"
                                name="personalEmail"
                                value={formData.personalEmail || ""}
                                onChange={handleChange}
                              />
                              {emailValidationMessage && (
                                <div className="text-danger">
                                  {emailValidationMessage}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>D.O.B</b>
                                <span className="text-danger">*</span>
                              </label>
                              <DatePicker
                                selected={formData.dateOfBirth ? new Date(formData.dateOfBirth) : null}
                                onChange={(date) => handleDateChange(date, "dateOfBirth")}
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                                placeholderText="Date Of Birth"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                                maxDate={new Date()}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>PAN</b>
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                required
                                maxLength="10"
                                minLength="10"
                                name="pan"
                                value={formData.pan || ""}
                                onChange={handleChange}
                                style={{ textTransform: "uppercase" }}
                              />
                              {panValidationMessage && (
                                <div className="text-danger">
                                  {panValidationMessage}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>Role</b>
                                <span className="text-danger">*</span>
                              </label>

                              <Select
                                options={roleOptions}
                                value={roleOptions.find(opt => opt.value === formData.role) || null}
                                onChange={(selectedOption) =>
                                  setFormData(prev => ({
                                    ...prev,
                                    role: selectedOption?.value || ""
                                  }))
                                }
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>Designation</b>
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={desigOptions}
                                value={desigOptions.find(opt => opt.value === formData.designation) || null}
                                onChange={(selectedOption) =>
                                  setFormData(prev => ({
                                    ...prev,
                                    designation: selectedOption?.value || ""
                                  }))
                                }
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col text-center mt-3">
                            <button
                              type="submit"
                              id="sbmtdata"
                              className={formData.actionType === "INSERT" ? "btn btn-success" : "btn btn-warning"}
                              disabled={!submitEnabled}
                            >
                              {formData.actionType === "INSERT"
                                ? "SUBMIT"
                                : "UPDATE"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {exitModal && (
            <>
              <div className="modal-backdrop fade show"></div>
              <div
                className="modal fade employee-modal show"
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
              >
                <div
                  className="modal-dialog modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Deactivate New Hire</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setExitModal(false)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleExitEmployeeSubmit}>
                        <div className="row">

                          <div className="col-md-4">
                            <label className="form-label fw-bold">
                              Employee Name :
                            </label>
                          </div>
                          <div className="col-md-8">
                            {exitFormData.firstName}
                          </div>

                          <div className="col-md-4">
                            <div className="mb-3">
                              <label className="form-label fw-bold">
                                Date of Deactivate
                                <span className="text-danger">*</span>
                              </label>

                            </div>
                          </div>

                          <div className="col-md-8">
                            <DatePicker
                              selected={exitFormData.exitDate}
                              onChange={(date) => handleExitEmpDateChange(date, "exitDate")}
                              className="form-control"
                              dateFormat="dd-MM-yyyy"
                              placeholderText="Date Of Deactivate"
                              showYearDropdown
                              showMonthDropdown
                              dropdownMode="select"
                              onKeyDown={(event) => event.preventDefault()}
                              required
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col text-center mt-3">
                            <button
                              type="submit"
                              id="sbmtdata"
                              className="btn btn-success"
                            >
                              SUBMIT
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>

          )}

          {showInstantOnboardingModal && (
            <>
              <div className="modal-backdrop fade show"></div>
              <div
                className="modal fade employee-modal show"
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
              >
                <div
                  className="modal-dialog modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Instant Onboarding - {instantOnboardData?.firstName}</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => { setShowInstantOnboardingModal(false); setInstantOnboardData({}) }}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={handleInstantOnboardingSubmit}>
                        <div className="row">
                          <div className="col-12 col-md-4">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>Employee ID</b>
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                required
                                name="empId"
                                placeholder="Enter Employee ID"
                                value={instantOnboardData.empId || ""}
                                onChange={(e) =>
                                  setInstantOnboardData((prev) => ({
                                    ...prev,
                                    empId: e.target.value,
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-4">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>Role</b>
                                <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={roleOptionsForApproval}
                                value={
                                  roleOptionsForApproval.find(
                                    (opt) => opt.value === instantOnboardData.role
                                  ) || null
                                }
                                onChange={(selectedOption) =>
                                  setInstantOnboardData((prev) => ({
                                    ...prev,
                                    role: selectedOption?.value,
                                  }))
                                }
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-4">
                            <div className="mb-3">
                              <label className="form-label">
                                <b>Joining Date</b>
                                <span className="text-danger">*</span>
                              </label>
                              <DatePicker
                                selected={instantOnboardData.joiningDate ? new Date(instantOnboardData.joiningDate) : null}
                                onChange={(date) => handleOnboardDateChange(date, "joiningDate")}
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                                placeholderText="Date Of Joining"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                onKeyDown={(event) => event.preventDefault()}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col text-center mt-3">
                            <button
                              type="submit"
                              id="sbmtdata"
                              className="btn btn-success"
                            >
                              SUBMIT
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>

          )}
        </div>
      </div>
    </div>
  );
};

export default NewHire;
